// src/api/kpis.js
import api from './axios';

/** List KPIs for a KPA */
export async function listKpis(kpaId) {
      const { data } = await api.get('/api/kpis', {
              // backend expects kpa_id
              params: { kpa_id: kpaId, per_page: 1000 },
     });
    return data?.data ?? [];
}

/** Create KPI
 * payload: {
 *   key_performance_area_id, name,
 *   threshold, target, stretch,
 *   weight, is_percentage, unit
 * }
 */
export async function createKpi(payload) {
    const { data } = await api.post('/api/kpis', payload);
    return data;
}

/** Update KPI */
export async function updateKpi(id, patch) {
    const { data } = await api.patch(`/api/kpis/${id}`, patch);
    return data;
}

/** Delete KPI */
export async function deleteKpi(id) {
    await api.delete(`/api/kpis/${id}`);
    return true;
}

/** Reorder KPIs within a KPA
 * items: [{ id, order }, ...]
 */
export async function reorderKpis(kpaId, items) {
    const { data } = await api.post(`/api/kpas/${kpaId}/kpis/reorder`, { items });
    return data;
}

/** List manager KPIs for the aligned manager KPA of this KPA */
export async function fetchManagerKpisForKpa(kpaId, opts = {}) {
    // opts.managerKpaId is optional; if provided, pass to backend as query (?manager_kpa_id=...)
    const params = {};
    if (opts.managerKpaId) params.manager_kpa_id = opts.managerKpaId;

    const { data } = await api.get(`/api/kpas/${kpaId}/manager-kpis`, { params });

    // Normalize various backend shapes:
    // 1) { manager: {...}, data: [...] }
    // 2) { items: [...] }
    // 3) [ ... ] (legacy array)
    let manager = null;
    let rows = [];

    if (Array.isArray(data)) {
        rows = data;
    } else if (data && typeof data === 'object') {
        manager = data.manager ?? null;

        if (Array.isArray(data.data)) {
            rows = data.data;
        } else if (Array.isArray(data.items)) {
            rows = data.items; // <-- your current backend shape
        } else if (Array.isArray(data.kpis)) {
            rows = data.kpis;  // just-in-case variant
        }
    }

    return { manager, kpis: rows };
}

/** Cascade selected manager KPIs into this target KPA */
export async function cascadeKpisIntoKpa(kpaId, { kpi_ids }) {
    return api.post(`/api/kpas/${kpaId}/kpis/cascade`, { kpi_ids });
}

// Validate KPI weights for a KPA (server returns any errors/warnings)
export async function validateKpiWeights(kpaId, payload = {}) {
    // if your backend expects a list, pass { items: [...] } via payload
    const { data } = await api.post(`/api/kpas/${kpaId}/kpis/validate-weights`, payload);
    return data;
}

// Back-compat alias for existing cascade
export async function cascadeManagerKpis(kpaId, { kpi_ids }) {
    return cascadeKpisIntoKpa(kpaId, { kpi_ids });
}